import EntityBase from '@/data/EntityBase';
import { Map } from 'immutable';
import type { Time } from '../models';

export default class TimeState extends EntityBase({
  items: Map<Time['id'], Time>(),
  updating: 0,
}) {}
